import { render, staticRenderFns } from "./DynamicMultipleChoice.vue?vue&type=template&id=f1a57554&scoped=true"
import script from "./DynamicMultipleChoice.vue?vue&type=script&lang=js"
export * from "./DynamicMultipleChoice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1a57554",
  null
  
)

export default component.exports